import { color, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-action-button";
const videoState = objectWithClassName({
  className: `${classNamePrefix}-video-state`,
  position: "absolute",
  bottom: "0",
  right: "0",
  width: "40px",
  height: "40px",
  zIndex: "9999",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  transition: `background-color 0.3s`,
  [`@media (${media.queries.tablet.min})`]: {
    width: "44px",
    height: "44px"
  },
  [`&:hover, &:focus`]: {
    backgroundColor: `rgba(0, 0, 0, 1)`
  },
  "& > svg": {
    fill: `${color.white}`,
    width: "20px"
  }
});
export {
  videoState
};
//# sourceMappingURL=button.js.map
